<template>
  <div>
    <div class="step">
      <div class="step__container">
        <div
          class="step__image"
          v-if="fields && fields.image && fields.image.value && fields.image.value.src"
        >
          <sc-image v-if="fields && fields.image" :media="fields.image" />
        </div>
        <div class="step__content">
          <sc-text
            tag="div"
            class="step__label"
            v-if="fields && fields.step"
            :field="fields.step"
          />
          <sc-text
            tag="div"
            class="step__headline"
            v-if="fields && fields.heading"
            :field="fields.heading"
          />
          <sc-text
            tag="div"
            class="step__description"
            v-if="fields && fields.description"
            :field="fields.description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Steps-Carousel-Item',
  components: {
    ScText: Text,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.step {
  &__container {
    @include desktop-up {
      display: flex;
      margin: 2.4rem 0 0 0;
    }
  }

  &__image {
    margin-bottom: 1.6rem;
    text-align: center;

    @include desktop-up {
      margin: 0 3.2rem 0 0;
    }

    img {
      width: 13rem;
      height: auto;

      @include desktop-up {
        width: 16rem;
      }
    }
  }

  &__content {
    margin: 1.4rem 0;
  }

  &__label {
    @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $orange);
    text-transform: uppercase;
    margin-bottom: 0.4rem;
  }

  &__headline {
    @include font-styles('Arial', 2rem, 500, normal, 2.6rem, 0, $white);
    margin-bottom: 0.8rem;
  }

  &__description {
    @include font-styles('Arial', 1.4rem, 500, normal, 1.8rem, 0, $white);
  }
}
</style>
